import React, { Component } from 'react';
import API from "components/Apis/API"
import toast from "react-hot-toast"

// Document list element
export class Documents extends Component {
  getOrderDocuments = async (event, order, type) => {
    try {
      // Prevent click from closing modal
      event.preventDefault();
      const url = "admin/get_order_documents";
      const formData = new FormData();
      formData.append('documentType', type);
      formData.append('orderId', order.id);

      const blob = await API.postData(url, formData, true);

      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element, set its href to the blob URL, and click it to open the PDF
      const link = document.createElement('a');
      link.href = blobUrl;
      link.target = '_blank'; // Open in a new tab
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  }

  componentDidMount() {
    const { order, documentType } = this.props;
    const url = "admin/get_order_documents";
    const formData = new FormData();
    formData.append('documentType', documentType);
    formData.append('orderId', order.id);

    API.postData(url, formData, true)
      .then(blob => {
        if (blob.type) {
          document.getElementById(`${documentType}DocumentButton`).hidden = false;
        } else {
          console.log(blob);
        }
      })
      .catch(error => {
        console.error('Error fetching document:', error);
      });
  }

  render() {
    const { order, documentType } = this.props;
    return (
      <div>
        <button
          id={`${documentType}DocumentButton`}
          className='btn btn-primary btn-xs'
          onClick={() => this.getOrderDocuments(event, order, documentType)}
          hidden
        >
          Open Document
        </button>
      </div>
    );
  }
}

// Document upload element
export class FileUpload extends Component {
  uploadOrderDocument = (event, order) => {
    const url = "admin/create_order_documents";
    const formData = new FormData();
    
    try {
      const selectElement = document.getElementById("attachDocumentType");
      const selectedOption = selectElement.options[selectElement.selectedIndex].value;
      const file = event.target.files[0];
      const validTypes = ['application/pdf', 'image/jpeg', 'image/png'];

      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type.");
        return;
      }

      formData.append('document', file);
      formData.append('documentType', selectedOption);
      formData.append('orderId', order.id);
      
      API.postData(url, formData)
        .then(response => {
          if (response.status) {
            document.getElementById(`${selectedOption}DocumentButton`).hidden = false;
            toast.success("Document Uploaded!");
          } else {
            throw new Error("Upload failed");
          }
        })
        .catch(error => {
          toast.error("Upload Failed!");
        });
    } catch (error) {
      toast.error("Upload Failed!");
    }    
  }

  render() {
    const { order } = this.props;
    return (
      <>
        <th>Attach Documents To Order:</th>
        <td>
          <label>
            Document Type:
          </label>
          <select id="attachDocumentType" className='form-control m-1 modalInput' clearable={true}>
            <option value="Carta Porte">Carta Porte</option>
            <option value="DODA">DODA</option>
            <option value="Prefile">Prefile</option>
            <option value="FOLIO">FOLIO</option>
            <option value="BOND">BOND</option>
            <option value="CI">CI</option>
            <option value="VIATPRO">VIATPRO</option>
          </select>
        </td>
        <td colSpan="2">
          <label>
            Choose Document:
          </label>
          <div>
            <input 
              className="form-control m-1 modalInput" 
              type="file" 
              multiple 
              accept=".jpeg,.jpg,.pdf,.png" 
              onChange={(event) => this.uploadOrderDocument(event, order)} 
            />
          </div>
        </td>
      </>
    );
  }
}